module.exports = __webpack_public_path__ + "static/Image08@2x-255eae17b7bc6f6e389ea878cdea7a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image08@2x.jpg
// module id = 901
// module chunks = 227233210825294 244429959259914